import {useCallback} from 'react'
import {useHistory} from 'react-router-dom'

import type {ModalId} from '../types'

const MODAL_QUERY_KEY = 'modal'

export function useModalControls(modalId: ModalId) {
  const {
    location: {search},
    replace,
  } = useHistory()

  const openModal = useCallback(() => {
    const searchParams = new URLSearchParams(search)
    searchParams.set(MODAL_QUERY_KEY, modalId)
    replace({search: searchParams.toString()})
  }, [modalId, replace, search])

  const closeModal = useCallback(() => {
    const searchParams = new URLSearchParams(search)
    searchParams.delete(MODAL_QUERY_KEY)
    replace({search: searchParams.toString()})
  }, [replace, search])

  return {
    openModal,
    closeModal,
  }
}
